'use client';
import NProgress from 'nprogress';
import { useSyncExternalStore } from 'react';

let isNavigating = false;
const listeners = new Set<() => void>();

const notify = () => listeners.forEach(l => l());

const originalStart = NProgress.start.bind(NProgress);
const originalDone = NProgress.done.bind(NProgress);

NProgress.start = () => {
  isNavigating = true;
  notify();
  return originalStart();
};

NProgress.done = (force?: boolean) => {
  isNavigating = false;
  notify();
  return originalDone(force);
};

export function useIsNavigating() {
  return useSyncExternalStore(
    (callback) => {
      listeners.add(callback);
      return () => listeners.delete(callback);
    },
    () => isNavigating,
    () => false,
  );
}
